const $ = require('jquery');

export default {
  init() {
    $('.js-show-more').on('click', (e: any) => {
      const target = $(e.currentTarget).data('target-id');
      $(e.currentTarget).toggleClass('is-active');
      $(`#${target}`).slideToggle();
      if ($(e.currentTarget).hasClass('is-active')) {
        $(e.currentTarget)
          .find('.js-show-more-label')
          .html($(e.currentTarget).data('show-more-text'));
      } else {
        $(e.currentTarget)
          .find('.js-show-more-label')
          .html($(e.currentTarget).data('show-less-text'));
      }
    });
  }
};
